import React, { useEffect, useState } from "react";
import "./App.css";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import Hompage from "./Components/Homepage/Homepage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Collection from "./Components/Collection/Collection";
import Dashboard from "./Components/Dashboard/Dashboard";
import About from "./Components/About";
import Contact from "./Components/Contact";
import Blog from "./Components/Blog/Blog";
import Login from "./Components/Login";
import Loader from "./Components/Homepage/Loader";
import sal from "sal.js";
import "../node_modules/sal.js/dist/sal.css";

function App() {
  return (
    <div className="App">
      <Loader />
      <Router>
        
        {/* This Navbar and Footer has been inported specifically in every file in order to solver problem of Loader */}
        {/* <Navbar /> */}

        <Routes>
          <Route exact path="/" element={<Hompage />} />

          <Route exact path="/Collection" element={<Collection />} />

          <Route exact path="/Dashboard" element={<Dashboard />} />

          <Route exact path="/About" element={<About />} />

          <Route exact path="/Contact" element={<Contact />} />

          <Route exact path="/Blog" element={<Blog />} />

          <Route exact path="/Login" element={<Login />} />
        </Routes>

        {/* <Footer /> */}
      </Router>
    </div>
  );
}

export default App;
